import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import { usePermission } from "../../../../permissions/usePermission";
import UserVerificationTable from "./UserProfileVerificationUpdate";
import ProfileUpdateTable from "./ProfileUpdate";
import JourneyApprovalTable from "./JourneyApproval";

const AdminUserApprovals = () => {
  const [tab, setTab] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, behaviour: "smooth" });
  }, []);

  const { canByKey } = usePermission();
  const canViewNewUserRequests = canByKey(
    "USER_MANAGEMENT_USER_APPROVAL_VIEW_NEW_USER_PENDING_REQUESTS",
  );
  const canViewProfileEditRequests = canByKey(
    "USER_MANAGEMENT_USER_APPROVAL_VIEW_USER_EDIT_PENDING_REQUESTS",
  );
  const canViewJourneyEditRequests = canByKey(
    "USER_MANAGEMENT_USER_APPROVAL_VIEW_JOURNEY_EDIT_PENDING_REQUESTS",
  );

  return (
    <>
    <Paper elevation={0} variant="pageBg">
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          User Approval Management
        </Typography>
      </Box>

      {/* <Paper
        elevation={3}
        sx={{
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      > */}
        {(() => {
          const tabs = [
            {
              label: "New User Verification",
              canView: canViewNewUserRequests,
              content: <UserVerificationTable />
            },
            {
              label: "Profile Update Requests",
              canView: canViewProfileEditRequests,
              content: <ProfileUpdateTable />
            },
            {
              label: "Journey Update Requests",
              canView: canViewJourneyEditRequests,
              content: <JourneyApprovalTable />
            }
          ];
          const visibleTabs = tabs.filter((t) => t.canView);
          const safeTab = Math.min(tab, visibleTabs.length - 1);

          return (
            <>
              <Tabs
                value={safeTab}
                onChange={(e, newValue) => setTab(newValue)}
                centered
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
                sx={{ 
                borderBottom: 1, 
                borderColor: "divider", 
                overflowX:"scroll", 
                borderBottom: 1,
                borderColor: "divider",
                overflowX: "auto",
                flex: 1,
                minWidth: 0,
                '& .MuiTabs-flexContainer': { gap: 1 },
                }}
              >
                {visibleTabs.map((t) => (
                  <Tab key={t.label} label={t.label} />
                ))}
              </Tabs>

              <Box sx={{ p: 2 }}>
                {visibleTabs[safeTab]?.content}
              </Box>
            </>
          );
        })()}
      {/* </Paper> */}
      </Paper>
    </>
  );
};

export default AdminUserApprovals;
